import { Stack } from '@mui/material';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { SearchInputField, ToggleSwitch } from '@retail/components';
import { useSuppliersTFunction } from '@retail/suppliers/i18n';
import { GridDensity } from '@mui/x-data-grid';
import { SuppliersDensityMenu } from './SuppliersDensityMenu';
import { OutlinedButton } from '@shared/components';

interface Props {
  searchInput: string;
  onSearchChange: (searchInput: string) => void;
  gridDensity: GridDensity;
  setGridDensity: Dispatch<SetStateAction<GridDensity>>;
  hasActiveAgreement: boolean;
  hasActiveAgreementToggle: () => void;
  openActivateAgreements?: () => void;
}

export const SuppliersTableToolbar: FC<Props> = ({
  searchInput,
  onSearchChange,
  gridDensity,
  setGridDensity,
  hasActiveAgreementToggle,
  hasActiveAgreement,
  openActivateAgreements,
}) => {
  const t = useSuppliersTFunction();

  const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  return (
    <Stack flexDirection="row" justifyContent="space-between" alignItems="center" px={3} py={2}>
      <SearchInputField
        placeholder={t('suppliers.actions.search')}
        value={searchInput}
        onChange={handleSearchInputChange}
        onReset={() => onSearchChange('')}
      />
      <Stack flexDirection="row" alignItems="center" gap={1}>
        <SuppliersDensityMenu gridDensity={gridDensity} setGridDensity={setGridDensity} />

        <ToggleSwitch
          toggle={hasActiveAgreement}
          setToggle={hasActiveAgreementToggle}
          text={t('suppliers.actions.showWithActiveAgreement')}
        />
        {openActivateAgreements && (
          <OutlinedButton size="small" onClick={openActivateAgreements}>
            {t('suppliers.actions.updateSuppliersAgreements')}
          </OutlinedButton>
        )}
      </Stack>
    </Stack>
  );
};
